import React, { useState, useEffect, useRef, memo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";

import { FiDownload, FiEye, FiEdit } from "react-icons/fi";
import moment from "moment";
import PatientForm from "../Forms/PatientForm";
import axiosInst from "../../../Config";
import { Decrypt_Value } from "../../../MiddleWare/EncryptDecrypt";

import {
  getUpdateDocumentslist,
  getDeleteDocumentslist,
  getPreviewDocument,
  getViewEditDocument,
  getDeleteTempDoc,
  getPreviewDownload,
  setPreviewDownload,
  getDownloadCredentials,
  getDownloadLabCredentials,
  getDeleteLabCredentials,
  setDeleteLabCredentials,
  getDocumentslist,
  getEditDataEmpty,
  setPreviewDocument,
} from "../../../StateManagement/Reducers/DocumentsState";

import CreateSignature from "../CreateSignature";
import ViewEdit from "../ViewEdit";
import EmptyData from "../../StyledComponents/EmptyData";
import Error from "../../../Modules/StyledComponents/Toastify/Error";

import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableHeadCell,
  TableBodyCell,
  Image,
  FlexJustCenter,
  Modal,
  ModalContainer,
  ModalTitle,
  Div,
} from "../../StyledComponents";
import {
  TableDiv,
  ProfileNameText,
  StatusDiv,
  StatusText,
  DropdownList,
  DropdownContent,
  Iframe,
  LinkA,
} from "./styles";

import { BsThreeDots, BsXLg } from "react-icons/bs";
import Download from "../../../Assets/images/Download.png";
import Delete from "../../../Assets/images/Delete.png";
import forward from "../../../Assets/images/forward.png";
import printer from "../../../Assets/images/printer.png";
import { TitleLabel } from "../../HomeWork/Styles";
import "../ViewEdit/Test.css";

const DocumentTable = ({ docTableData, documenthead }) => {
  const dispatch = useDispatch();
  const componentRef = useRef();
  const newTabRef = useRef(null);

  const [editopen, setEditopen] = useState("");
  const [iscreate, setIsCreate] = useState();
  const [forprint, setforprint] = useState("");
  const [tosign, settosign] = useState("");
  const [documentlistdata, setdocumentlistdata] = useState([]);
  const [donwloadprintid, setdonwloadprintid] = useState("");
  const [ForViewEdit, setForViewEdit] = useState(false);

  const [isFormOpened, setIsFormOpened] = useState(false);
  const [formData, setFormData] = useState(null);

  const [FileName, setFileName] = useState("");
  const [FileStatus, setFileStatus] = useState("");
  const [ForSign, setForSign] = useState("");
  const [FileId, setFileId] = useState("");
  const [viewedDocs, setViewedDocs] = useState([]);
  const [viewModalUrl, setViewModalUrl] = useState("");

  let backurl = "";
  let firstDot = window.location.hostname.split(".");
  let DBhost;

  if (firstDot[0] !== "localhost") {
    backurl = process.env.REACT_APP_BACKEND_FILE_ACCESS.replace(
      "oemr",
      firstDot[0],
    );
  } else {
    backurl = process.env.REACT_APP_BACKEND_FILE_ACCESS;
  }

  if (
    firstDot[0] === "localhost" ||
    firstDot[0] === "test" ||
    firstDot[0] === "mumbai" ||
    firstDot[0] === "production" ||
    firstDot[0] === "ehr" ||
    firstDot[0] === "ehr1" ||
    firstDot[0] === "dev"
  ) {
    DBhost = "default";
  } else {
    DBhost = firstDot[0];
  }

  const FileURL = backurl + "/sites/" + DBhost + "/documentimg/";
  const LabFileURL = backurl + "/sites/" + DBhost + "/LabDocuments/";
  const FileURLProfile = backurl + "/sites/" + DBhost + "/documentimg/";

  const PreviewDownload = useSelector(
    (state) => state.Document.previewdownload,
  );
  const DocumentDownloadUrl = useSelector(
    (state) => state.Document.DownloadDocumentlist,
  );
  const LabDocumentDownloadUrl = useSelector((state) => state.Document.LabPdf);

  const setEditAction = (ind) => {
    setEditopen((prev) => (prev === ind ? "" : ind));
  };

  const SentToReview = (ind, id, status) => {
    if (status === "In Review") {
      toast(<Error msg="This Document Already Sent to Review" />, {
        containerId: "B",
        className: "error_badge",
      });
      setEditAction(ind);
    } else if (status === "Locked") {
      toast(<Error msg="This Document is Already Locked" />, {
        containerId: "B",
        className: "error_badge",
      });
      setEditAction(ind);
    } else {
      dispatch(getUpdateDocumentslist({ ids: id }));
      setEditAction(ind);
    }
  };

  const HandlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => dispatch(getDeleteTempDoc({ id: donwloadprintid })),
  });

  const FileDownload = async (fileurl, id, ind) => {
    setdonwloadprintid(id);
    dispatch(getPreviewDownload({ file: fileurl, id: id, testurl: FileURL }));
    setEditAction(ind);
  };

  const HandleDelete = (ind, id) => {
    if (window.confirm("Are you sure you want to Delete?")) {
      dispatch(setPreviewDocument(""));
      setTimeout(() => {
        dispatch(getDeleteDocumentslist({ ids: id }));
        setEditAction(ind);
      }, 0);
    }
  };

  // const PreviewDocument = (id, fileurl, print, ind) => {
  //   setdonwloadprintid(id);
  //   if (print === "yes") {
  //     setEditAction(ind);
  //     setforprint("yes");
  //   } else {
  //     setforprint("no");
  //   }
  //   dispatch(getPreviewDocument({ file: fileurl, id: id }));
  // };

  // const PreviewDocument = (id, fileurl, print, ind) => {
  //   // 1. CHECK IF CLICKING THE SAME DOCUMENT
  //   if (donwloadprintid === id) {
  //     if (print === "yes") {
  //       setEditAction(ind);
  //       setforprint("yes");
  //       // The document is already loaded in the hidden iframe, so print it instantly
  //       setTimeout(() => {
  //         HandlePrint();
  //         setforprint("");
  //       }, 500);
  //     } else {
  //       // The URL is already loaded in Redux, so click the hidden view link instantly
  //       const viewLink = document.getElementById("preview_document");
  //       if (viewLink) {
  //         viewLink.click();
  //       }
  //     }
  //     return; // Exit the function early so it DOES NOT dispatch to the backend!
  //   }

  //   // 2. IF CLICKING A DIFFERENT DOCUMENT (OR FIRST TIME)
  //   setdonwloadprintid(id); // Update to the new ID

  //   if (print === "yes") {
  //     setEditAction(ind);
  //     setforprint("yes");
  //   } else {
  //     setforprint("no");
  //   }

  //   // Dispatch to fetch/convert the new document
  //   dispatch(getPreviewDocument({ file: fileurl, id: id }));
  // };


  const PreviewDocument = (id, fileurl, print, ind) => {
    setdonwloadprintid(id);

    if (print === "yes") {
      setEditAction(ind);
      setforprint("yes");

      // SYNCHRONOUS TAB OPEN for Print: Bypasses browser pop-up blockers!
      const newWin = window.open("", "_blank");
      if (newWin) {
        newWin.document.write(
          "<h3 style='font-family:sans-serif; text-align:center; margin-top:50px; color:#555;'>Preparing Document...</h3>"
        );
        newTabRef.current = newWin;
      }
    } else {
      // View action: no new tab, we'll show a modal instead
      setforprint("no");
    }

    // Dispatch to fetch/convert the document (.tpl to .pdf)
    dispatch(getPreviewDocument({ file: fileurl, id: id }));
  };

  // useEffect(() => {
  //   if (DocumentDownloadUrl && DocumentDownloadUrl !== "") {

  //     // 1. SAFEGUARD: Stop if the backend returns a cURL error instead of a file
  //     if (typeof DocumentDownloadUrl === "string" && DocumentDownloadUrl.includes("cURL Error")) {
  //       toast.error("Failed to fetch the document from the server.");
  //       setforprint(""); // Reset
  //       return; 
  //     }

  //     // 2. STRICT CHECKS to prevent auto-firing on page load
  //     if (forprint === "yes") {
  //       // --- PRINT ACTION ---
  //       setTimeout(() => {
  //         HandlePrint();
  //         setforprint(""); // Reset the print state
  //       }, 1000); 

  //     } else if (forprint === "no") { 
  //       // --- VIEW ACTION ---
  //       // By using 'else if', this will ONLY run if we specifically clicked the view button.
  //       const viewLink = document.getElementById("preview_document");
  //       if (viewLink) {
  //         viewLink.click();
  //       }
  //       setforprint(""); // Reset the state so it doesn't auto-fire on refresh!
  //     }
  //   }
  // }, [DocumentDownloadUrl]);

  // Fix: Clear the Redux state when the component unmounts so it doesn't
  // auto-trigger the last viewed document when returning to this page.

  useEffect(() => {
    if (DocumentDownloadUrl && DocumentDownloadUrl !== "") {

      // SAFEGUARD: Catch backend cURL errors
      if (typeof DocumentDownloadUrl === "string" && DocumentDownloadUrl.includes("cURL Error")) {
        toast.error("Failed to fetch the document from the server.");
        setforprint("");
        if (newTabRef.current) {
          newTabRef.current.close(); // Close the loading tab
          newTabRef.current = null;
        }
        dispatch(setPreviewDocument("")); // Clear Redux
        return;
      }

      // Format the final URL correctly
      let file = typeof DocumentDownloadUrl === "object" ? DocumentDownloadUrl.file : DocumentDownloadUrl;
      let finalUrl = file;
      if (file && !file.includes("http") && !file.includes("blob:") && !file.includes("data:")) {
        finalUrl = file.startsWith("/documents/")
          ? backurl + "/sites/" + DBhost + file
          : FileURL + file;

      }

      if (forprint === "yes") {
        // --- PRINT ACTION ---
        if (newTabRef.current) {
          // Check if it's an image (by extension OR by original filename if extension is missing)
          let isImage = false;
          if (finalUrl.match(/\.(jpeg|jpg|gif|png|webp|bmp)(\?.*)?$/i)) {
            isImage = true;
          } else {
            const row = documentlistdata.find((r) => r.id === donwloadprintid);
            if (row) {
              const name = (row.doc_name || row.file_url || "").toLowerCase();
              if (name.match(/[\.-](jpeg|jpg|gif|png|webp|bmp)/i)) {
                isImage = true;
              }
            }
          }
          
          if (isImage) {
             // Close the temporary loading tab
             newTabRef.current.close();
             newTabRef.current = null;

             // Print silently using a hidden iframe
             const iframe = document.createElement('iframe');
             iframe.style.display = 'none';
             document.body.appendChild(iframe);
             iframe.contentDocument.write(`
               <html>
                 <head>
                   <title>Print Image</title>
                   <style>
                     body { margin: 0; }
                     @media print {
                       @page { margin: 0.5cm; }
                       body { background: white; margin: 0; }
                       .print-img { max-width: 100%; max-height: 98vh !important; box-shadow: none !important; object-fit: contain; }
                     }
                   </style>
                 </head>
                 <body>
                   <img class="print-img" src="${finalUrl}" onload="setTimeout(() => { window.print(); }, 200);" />
                 </body>
               </html>
             `);
             iframe.contentDocument.close();

             // Cleanup the iframe after a generous delay so the print dialog isn't interrupted
             setTimeout(() => {
               if (document.body.contains(iframe)) {
                 document.body.removeChild(iframe);
               }
             }, 60000);

          } else {
             // For PDFs, just load the URL and let the native PDF viewer handle it
             newTabRef.current.location.href = finalUrl;
             newTabRef.current = null;
          }
        }

        setforprint("");
        dispatch(setPreviewDocument("")); // Clear Redux after opening

      } else if (forprint === "no") {
        // --- VIEW ACTION ---
        // Show the PDF inside an in-app modal
        setViewModalUrl(finalUrl);

        setforprint("");
        dispatch(setPreviewDocument(""));
      }
    }
  }, [DocumentDownloadUrl]);

  // Unmount Cleanup
  useEffect(() => {
    dispatch(setPreviewDocument(""));
    dispatch(setPreviewDownload(""));   // plain reset, no API call

    return () => {
      dispatch(setPreviewDocument(""));
      dispatch(setPreviewDownload(""));
    };
  }, [dispatch]);

  const PreviewDocumentEdit = (id, fileurl, fname, status, sign) => {
    setForViewEdit(true);
    setFileName(fname);
    setFileStatus(status);
    setForSign(sign);
    setFileId(id);
    dispatch(getViewEditDocument({ file: fileurl, id: id }));
  };

  const HanldeCloseSignature = () => {
    setIsCreate(false);
    settosign("");
  };

  const HanldeCloseViewEdit = () => {
    setForViewEdit(false);
    dispatch(getDocumentslist({ filtertype: "All Documents" }));
    dispatch(getEditDataEmpty());
  };

  const getFileExtension = (filename) => filename.split(".").pop();

  const handleDownload = (value) => {
    dispatch(getDownloadCredentials({ order_id: value, result: 1 }));
  };

  const handleDownloadLab = (order_id, id, pid, testcode, filename) => {
    dispatch(
      getDownloadLabCredentials({
        order_id,
        id,
        pid,
        testcode,
        filename,
      }),
    );
  };

  const handleClick = (e) => {
    if (!e.target.id) setEditopen("");
  };

  const truncateText = (text, maxLength) =>
    text?.length > maxLength ? text.substring(0, maxLength) + "..." : text;

  const openPatientAssessment = (row) => {
    const formLabel = row.screening_form || row.assess_form || row.form_name;

    if (!formLabel) {
      toast.error("Assessment form name missing");
      return;
    }

    axiosInst
      .get(
        `/vozo/getPatientForm?pid=${row.pid}&formLabel=${formLabel}&docId=${row.id}`,
      )
      .then((response) => {
        let decryptedData =
          typeof response.data === "string"
            ? Decrypt_Value(response.data, "vozo")
            : response.data;

        if (!decryptedData || Object.keys(decryptedData).length === 0) {
          toast.error("Form data not available");
          return;
        }

        decryptedData.pid = row.pid;
        decryptedData.document_id = row.id;

        const hasFilledValues = decryptedData.questions?.some(
          (q) =>
            q.selected_option !== null &&
            q.selected_option !== undefined &&
            q.selected_option !== "" &&
            q.selected_option !== 0,
        );

        decryptedData.isSaved = hasFilledValues;

        setFormData(decryptedData);
        setIsFormOpened(true);
      })
      .catch(() => {
        toast.error("Unable to load assessment form");
      });
  };

  useEffect(() => {
    if (docTableData) {
      const sortedArray = [...docTableData].sort((a, b) => {
        if (a.assignedByDefault === 1 && b.assignedByDefault !== 1) return -1;
        if (b.assignedByDefault === 1 && a.assignedByDefault !== 1) return 1;
        return b.id - a.id;
      });
      setdocumentlistdata(sortedArray);
    }
  }, [docTableData]);

  useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  useEffect(() => {
    console.log("PreviewDownload updated:", PreviewDownload);
    if (PreviewDownload && PreviewDownload !== "") {
      const isObject = typeof PreviewDownload === "object";
      const file = isObject ? PreviewDownload.file : PreviewDownload;
      const filename = isObject ? PreviewDownload.filename : "document.pdf";
      const downloadId = isObject ? PreviewDownload.id : donwloadprintid;

      if (!file) {
        console.error("No file URL found in PreviewDownload");
        return;
      }

      console.log("Triggering download for:", file);

      let tag = document.createElement("a");
      const fullUrl =
        file?.includes("http") ||
          file?.includes("blob:") ||
          file?.includes("data:")
          ? file
          : (isObject ? PreviewDownload.testurl || FileURL : FileURL) + file;

      tag.href = fullUrl;
      tag.download = filename;
      tag.target = "_blank"; // Fallback for some browsers
      document.body.appendChild(tag);
      tag.click();
      document.body.removeChild(tag);

      // Delay cleanup slightly to ensure trigger is handled by browser
      setTimeout(() => {
        dispatch(getDeleteTempDoc({ id: downloadId }));
      }, 1000);
    }
  }, [PreviewDownload]);

  useEffect(() => {
    if (LabDocumentDownloadUrl !== "") {
      let tag = document.createElement("a");
      tag.href = LabDocumentDownloadUrl.includes("http")
        ? LabDocumentDownloadUrl
        : LabFileURL + LabDocumentDownloadUrl;
      tag.target = "_blank";
      document.body.appendChild(tag);
      tag.click();
      document.body.removeChild(tag);
      dispatch(setDeleteLabCredentials(""));
    }
  }, [LabDocumentDownloadUrl]);

  const getStatusStyle = (status) => {
    switch (status) {
      case "Pending":
        return {
          bg: "rgba(255, 99, 71, 0.1)",
          color: "#ff6347",
          width: "100px",
        };

      case "Signed":
        return {
          bg: "rgba(40, 167, 69, 0.1)",
          color: "#28a745",
          width: "100px",
        };

      case "Unsigned":
        return {
          bg: "rgba(255, 159, 67, 0.1)",
          color: "#ff9f43",
          width: "100px",
        };

      case "In Review":
        return {
          bg: "rgba(132, 129, 138, 0.15)",
          color: "#84818a",
          width: "100px",
        };

      case "New":
        return {
          bg: "rgba(0, 165, 255, 0.1)",
          color: "#00a5ff",
          width: "100px",
        };

      case "Viewed":
        return {
          bg: "rgba(111, 66, 193, 0.1)",
          color: "#6f42c1",
          width: "100px",
        };

      case "Completed":
        return {
          bg: "rgba(40, 167, 69, 0.15)",
          color: "#218838",
          width: "100px",
        };

      default:
        return { bg: "rgba(132,129,138,0.1)", color: "#2e2c34", width: "100px" };
    }
  };

  return (
    <>
      {documenthead === "Lab Results" ? (
        <TableDiv>
          <Iframe
            seamless="seamless"
            width="100%"
            height="800px"
            ref={componentRef}
            src={
              DocumentDownloadUrl &&
                !DocumentDownloadUrl.toString().includes("cURL Error")
                ? FileURL + DocumentDownloadUrl
                : undefined
            }
          />
          <LinkA
            href={FileURL + DocumentDownloadUrl}
            target="_blank"
            id="preview_document"
          />
          <LinkA
            href={LabFileURL + LabDocumentDownloadUrl}
            target="_blank"
            id="lab_preview_document"
          />

          <Table>
            <TableHead>
              <TableRow background="#F7F7F7">
                <TableHeadCell width="20%" color="#407BFF">
                  Form
                </TableHeadCell>
                <TableHeadCell width="20%" color="#407BFF">
                  Title
                </TableHeadCell>
                <TableHeadCell
                  width="20%"
                  color="#407BFF"
                  style={{
                    paddingRight: "20px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Associate Patient
                </TableHeadCell>
                <TableHeadCell width="15%" color="#407BFF">
                  Created
                </TableHeadCell>
                <TableHeadCell width="15%" color="#407BFF">
                  Updated
                </TableHeadCell>
                <TableHeadCell width="10%" color="#407BFF">
                  Download
                </TableHeadCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <>
                {documentlistdata.length > 0 ? (
                  <>
                    {documentlistdata.map((row, ind) => (
                      <TableRow background="#FFFFF" key={row.id}>
                        <TableBodyCell
                          fontFamily="'Inter',sans-serif"
                          padding="16px 40px 10px 38px;"
                          cursor="pointer"
                          onClick={() => {
                            if (row.name === "lab") {
                              handleDownloadLab(
                                row.order_id,
                                row.procedure_order_id,
                                row.patient_id,
                                row.vendor + "-" + row.tests,
                                row.filename,
                              );
                            } else {
                              PreviewDocument(row.id, row.file_url, "no", ind);
                            }
                          }}
                        >
                          {" "}
                          <FlexJustCenter>
                            <TitleLabel
                              fontFamily="'Inter',sans-serif"
                              fontSize="14px"
                              fontHeight="16px"
                              fontWeight="normal"
                              color="#000000"
                              title={row.vendor}
                            >
                              {row.vendor}
                            </TitleLabel>
                          </FlexJustCenter>
                        </TableBodyCell>
                        <TableBodyCell
                          fontFamily="'Inter',sans-serif"
                          padding="16px 40px 10px 38px;"
                        >
                          {row.tests}
                        </TableBodyCell>
                        <TableBodyCell
                          display="flex"
                          fontFamily="'Inter',sans-serif"
                          padding="16px 40px 10px 38px;"
                          alignItems="center"
                        >
                          {row.pat_img_url !== null ? (
                            <Image
                              objectFit="cover"
                              loading="lazy"
                              width="28px"
                              height="28px"
                              borderRadius="50%"
                              margin="0 12px 0 0"
                              src={FileURLProfile + row.pat_img_url}
                            />
                          ) : (
                            <ProfileNameText>
                              {row.pat_name.charAt(0).toUpperCase()}
                            </ProfileNameText>
                          )}
                          {row.pat_name}
                        </TableBodyCell>

                        <TableBodyCell padding="16px 40px 10px 38px;">
                          {moment(row.date_submit).calendar(null, {
                            sameDay: "[Today]",
                            nextDay: "[Tomorrow]",
                            nextWeek: "dddd",
                            lastDay: "[Yesterday]",
                            lastWeek: "DD MMM  YYYY ",
                            sameElse: "DD MMM  YYYY ",
                          })}
                        </TableBodyCell>
                        <TableBodyCell padding="16px 40px 10px 38px;">
                          {moment(row.update_date).calendar(null, {
                            sameDay: "[Today]",
                            nextDay: "[Tomorrow]",
                            nextWeek: "dddd",
                            lastDay: "[Yesterday]",
                            lastWeek: "DD MMM  YYYY ",
                            sameElse: "DD MMM  YYYY ",
                          })}
                        </TableBodyCell>
                        <TableBodyCell padding="16px 68px 10px 38px;">
                          <StatusDiv
                            width="32px"
                            background="#FFFFFF"
                            style={{
                              boxShadow:
                                "0px 1px 3px rgba(0, 0, 0, 0.07), 0px 0.5px 2px rgba(0, 0, 0, 0.07)",
                              borderRadius: "4px",
                              float: "right",
                              cursor:
                                row.status !== "active"
                                  ? "pointer"
                                  : "not-allowed",
                              height: "32px",
                              display: "flex",
                            }}
                            onClick={() => {
                              if (row.status !== "active") {
                                if (row.name === "lab") {
                                  handleDownloadLab(
                                    row.order_id,
                                    row.procedure_order_id,
                                    row.patient_id,
                                    row.vendor + "-" + row.tests,
                                    row.filename,
                                  );
                                } else {
                                  handleDownload(row.order_id);
                                }
                              }
                            }}
                          >
                            <FiDownload
                              style={{
                                height: "18px",
                                width: "18px",
                                color: " #2c7be5",
                                cursor:
                                  row.status !== "active"
                                    ? "pointer"
                                    : "not-allowed",
                              }}
                            />
                          </StatusDiv>
                        </TableBodyCell>
                      </TableRow>
                    ))}
                  </>
                ) : (
                  <TableRow background="#FFFFF">
                    <TableBodyCell colSpan={6} textAlign="center">
                      <EmptyData height="60vh" />
                    </TableBodyCell>
                  </TableRow>
                )}
              </>
            </TableBody>
          </Table>
        </TableDiv>
      ) : (
        <TableDiv>
          <Iframe
            seamless="seamless"
            width="100%"
            height="800px"
            ref={componentRef}
            src={
              DocumentDownloadUrl &&
                !DocumentDownloadUrl.toString().includes("cURL Error")
                ? FileURL + DocumentDownloadUrl
                : undefined
            }
          />
          <LinkA
            href={FileURL + DocumentDownloadUrl}
            target="_blank"
            id="preview_document"
          />

          <Table>
            <TableHead>
              <TableRow background="#F7F7F7">
                <TableHeadCell width="28%" color="#407BFF">
                  Document
                </TableHeadCell>
                <TableHeadCell
                  width="18%"
                  color="#407BFF"
                  style={{ whiteSpace: "nowrap", paddingLeft: "16px" }}
                >
                  Create Date
                </TableHeadCell>
                <TableHeadCell width="18%" color="#407BFF">
                  Shared By
                </TableHeadCell>
                <TableHeadCell width="15%" color="#407BFF">
                  Type
                </TableHeadCell>
                <TableHeadCell
                  width="12%"
                  color="#407BFF"
                  padding="20px 0px 20px 70px"
                >
                  Status
                </TableHeadCell>
                <TableHeadCell width="9%" color="#407BFF">
                  Action
                </TableHeadCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <>
                {documentlistdata.length > 0 ? (
                  <>
                    {documentlistdata.map((row, ind) => (
                      <TableRow background="#FFFFF" key={row.id}>
                        <TableBodyCell
                          fontFamily="'Inter',sans-serif"
                          padding="16px 40px 10px 38px;"
                          cursor="pointer"
                          width="28%"
                          whiteSpace="normal"
                          overflowWrap="break-word"
                          onClick={() => {
                            /*STATUS CHANGE FIX */
                            const isAssessment = row.screening_form || row.assess_form;

                            if (row.status === "New" && !isAssessment) {
                              setViewedDocs((prev) => [...prev, row.id]);
                            }

                            if (row.screening_form || row.assess_form) {
                              openPatientAssessment(row);
                              return;
                            }

                            // THE MAGIC FIX: Since the API doesn't give us pathname, we manually construct it!
                            // We know the filled file is in the patient's folder (/27/) instead of /NotAssigned/
                            let trueFilePath = row.file_url;
                            if (trueFilePath && trueFilePath.includes("NotAssigned")) {
                              trueFilePath = trueFilePath.replace("NotAssigned", row.pid);
                            }

                            if (
                              row.status === "In Review" ||
                              row.status === "Locked" ||
                              row.is_share !== "yes" ||
                              row.note_type === 4
                            ) {
                              PreviewDocument(row.id, trueFilePath, "no", ind);
                              return;
                            }

                            if (
                              row.tags === "By Provider" ||
                              row.tags === "PCE"
                            ) {
                              PreviewDocument(row.id, trueFilePath, "no", ind);
                              return;
                            }

                            PreviewDocumentEdit(
                              row.id,
                              row.file_url,
                              row.form_name,
                              row.status,
                              row.req_pat_sign,
                            );
                          }}
                        >
                          <FlexJustCenter>
                            <TitleLabel
                              cursor="pointer"
                              fontFamily="'Inter',sans-serif"
                              fontSize="14px"
                              fontHeight="16px"
                              fontWeight="normal"
                              color="#000000"
                              title={row.form_name}
                            >
                              {truncateText(row.form_name, 26)}
                            </TitleLabel>
                          </FlexJustCenter>
                        </TableBodyCell>
                        <TableBodyCell
                          fontFamily="'Inter',sans-serif"
                          padding="16px 40px 10px 16px;"
                          whiteSpace="nowrap"
                        >
                          {row.date}
                        </TableBodyCell>
                        <TableBodyCell
                          display="flex"
                          fontFamily="'Inter',sans-serif"
                          padding="16px 40px 10px 38px;"
                          alignItems="center"
                          width="max-content"
                        >
                          {row.prov_img_url !== null ? (
                            <Image
                              objectFit="cover"
                              loading="lazy"
                              width="28px"
                              height="28px"
                              borderRadius="50%"
                              margin="0 12px 0 0"
                              src={FileURLProfile + row.prov_img_url}
                            />
                          ) : (
                            <ProfileNameText>
                              {row.prov_name_split}
                            </ProfileNameText>
                          )}
                          {row.username}
                        </TableBodyCell>
                        <TableBodyCell padding="16px 0px 10px 38px;">
                          {row.screening_form
                            ? "Assessment"
                            : row.assess_form
                              ? "Assessment"
                              : row.document_type
                                ? row.document_type
                                : row.form_name
                                  ?.toLowerCase()
                                  .includes("intake")
                                  ? "Intake"
                                  : "Others"}
                        </TableBodyCell>
                        {/* <TableBodyCell padding="16px 0px 10px 38px;">
                          {row.status === "In Review" && (
                            <StatusDiv
                              width="80px"
                              background="rgba(32, 201, 172, 0.1)"
                            >
                              <StatusText color="#20c9ac">
                                {row.status}
                              </StatusText>
                            </StatusDiv>
                          )}
                          {row.status === "New" && (
                            <StatusDiv
                              width="50px"
                              background=" rgba(0, 165, 255, 0.1)"
                            >
                              <StatusText color="#00a5ff">
                                {row.status}
                              </StatusText>
                            </StatusDiv>
                          )}
                          {row.status === "Locked" && (
                            <StatusDiv
                              width="80px"
                              background="rgba(132, 129, 138, 0.1)"
                            >
                              <StatusText color="#2e2c34">
                                {row.status}
                              </StatusText>
                            </StatusDiv>
                          )}
                        </TableBodyCell> */}
                        <TableBodyCell padding="16px 0px 10px 38px;">
                          {(() => {
                            // const displayStatus =
                            console.log(`Row Data for ${row.form_name || row.id}:`, row);
                            let displayStatus = row.status;
                            const isAssessment = row.screening_form || row.assess_form;
                            const requiresSign = row.req_pat_sign === "yes" || row.req_pat_sign === 1 || row.req_pat_sign === "1";

                            // A form is only "actionable" (showing Pending) if it is an assessment or it has fillable fields.
                            // If it has no fields, it is just a read-only document and should just show "New".
                            const isActionableForm = ((row.is_share === "yes" && row.tags !== "By Provider" && row.tags !== "PCE") || isAssessment)
                              && row.note_type !== 4
                              && (row.has_fields === true || requiresSign);

                            // A document is considered "saved" by the patient if the backend has generated a temp_url for it.
                            const isSaved = row.temp_url !== null && row.temp_url !== "";

                            if (isActionableForm) {
                              // Forms sent from the provider portal that require action
                              if (row.status === "New" && !isSaved) {
                                displayStatus = "Pending";
                              } else if (requiresSign && !isAssessment) {
                                // Sign & Save forms
                                if (row.status === "Signed" || row.status === "Locked") {
                                  displayStatus = "Signed";
                                } else if (row.status === "In Review") {
                                  displayStatus = "In Review";
                                } else {
                                  // Fallback for any other saved-but-not-signed status
                                  displayStatus = "Unsigned";
                                }
                              } else {
                                // View & Save forms (no signature needed)
                                // If we reach here, it's either saved or has a backend status other than New
                                if (row.status === "In Review") {
                                  displayStatus = "In Review";
                                } else {
                                  displayStatus = "Completed";
                                }
                              }
                            } else {
                              // Documents uploaded by the patient OR read-only documents
                              if (row.status === "Locked" || row.status === "Signed") {
                                if (row.signed === "Yes") {
                                  displayStatus = "Signed";
                                } else {
                                  displayStatus = "Completed";
                                }
                              } else if (row.status === "New" && viewedDocs.includes(row.id)) {
                                displayStatus = "Viewed";
                              }
                            }

                            const style = getStatusStyle(displayStatus);

                            return (
                              <StatusDiv
                                width={style.width}
                                background={style.bg}
                              >
                                <StatusText color={style.color}>
                                  {displayStatus}
                                </StatusText>
                              </StatusDiv>
                            );
                          })()}
                        </TableBodyCell>
                        <TableBodyCell
                          padding="16px 40px 10px 38px;"
                          style={{
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            gap: "14px",
                          }}
                        >
                          {/* Conditional View / Edit Icon */}
                          {(() => {
                            const isSaved = row.temp_url !== null && row.temp_url !== "";
                            const isAssessment = row.screening_form || row.assess_form;
                            const requiresSign = row.req_pat_sign === "yes" || row.req_pat_sign === 1 || row.req_pat_sign === "1";

                            const isActionableForm = ((row.is_share === "yes" && row.tags !== "By Provider" && row.tags !== "PCE") || isAssessment)
                              && row.note_type !== 4
                              && (row.has_fields === true || requiresSign);

                            return row.status === "Viewed" ||
                              row.status === "Completed" ||
                              row.status === "In Review" ||
                              row.status === "Locked" ||
                              row.status === "Signed" ||
                              (row.status === "New" && !isActionableForm) ||
                              row.note_type === 4;
                          })() ? (
                            <FiEye
                              style={{
                                fontSize: 18,
                                cursor: "pointer",
                                color: "#212121",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();

                                /* 🔥 STATUS CHANGE FIX */
                                const isAssessment =
                                  row.screening_form || row.assess_form;

                                if (row.status === "New" && !isAssessment) {
                                  setViewedDocs((prev) => [...prev, row.id]);
                                }

                                if (row.screening_form || row.assess_form) {
                                  openPatientAssessment(row);
                                  return;
                                }

                                if (
                                  row.status === "In Review" ||
                                  row.status === "Locked" ||
                                  row.is_share !== "yes" ||
                                  row.note_type === 4
                                ) {
                                  PreviewDocument(
                                    row.id,
                                    row.file_url,
                                    "no",
                                    ind,
                                  );
                                  return;
                                }

                                if (
                                  row.tags === "By Provider" ||
                                  row.tags === "PCE"
                                ) {
                                  PreviewDocument(
                                    row.id,
                                    row.file_url,
                                    "no",
                                    ind,
                                  );
                                  return;
                                }

                                PreviewDocumentEdit(
                                  row.id,
                                  row.file_url,
                                  row.form_name,
                                  row.status,
                                  row.req_pat_sign,
                                );
                              }}
                            />
                          ) : (
                            <FiEdit
                              style={{
                                fontSize: 18,
                                cursor: row.status === "In Review" ? "not-allowed" : "pointer",
                                color: row.status === "In Review" ? "#ccc" : "#212121",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (row.status === "In Review") return;

                                if (row.screening_form || row.assess_form) {
                                  openPatientAssessment(row);
                                  return;
                                }

                                PreviewDocumentEdit(
                                  row.id,
                                  row.file_url,
                                  row.form_name,
                                  row.status,
                                  row.req_pat_sign,
                                );
                              }}
                            />
                          )}

                          {/* Triple Dot */}
                          <BsThreeDots
                            id="icon"
                            style={{ fontSize: 20, cursor: "pointer" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setEditAction(ind);
                            }}
                          />

                          <DropdownContent
                            marginLeft="-138px"
                            width="179px"
                            marginRight="16px"
                            display={editopen === ind ? "true" : "false"}
                            share={row.is_share}
                          >
                            {row.is_share !== "yes" && (
                              <>
                                {row.status !== "Locked" && row.status !== "In Review" && (
                                  <DropdownList
                                    id="list"
                                    padding="0px 0px 3px 20px"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      SentToReview(ind, row.id, row.status);
                                    }}
                                  >
                                    <Image
                                      objectFit="cover"
                                      width="16px"
                                      height="16px"
                                      margin="0px 16px 0px 0px"
                                      src={forward}
                                      id="doc_rvw-snt_img"
                                    />
                                    Send to Review
                                  </DropdownList>
                                )}
                              </>
                            )}

                            {(row.status === "In Review" ||
                              (row.is_share !== "yes" &&
                                (row.status === "New" ||
                                  row.status === "Locked" ||
                                  row.status === "In Review"))) && (
                                <>
                                  <DropdownList
                                    id="list2"
                                    padding="0px 0px 3px 20px"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      PreviewDocument(
                                        row.id,
                                        row.file_url,
                                        "yes",
                                        ind,
                                      );
                                    }}
                                  >
                                    <Image
                                      loading="lazy"
                                      width="16px"
                                      height="16px"
                                      margin="0px 16px 0px 0px"
                                      src={printer}
                                    />
                                    Print
                                  </DropdownList>
                                  <DropdownList
                                    id="list3"
                                    padding="0px 0px 3px 20px"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      FileDownload(row.file_url, row.id, ind);
                                    }}
                                  >
                                    <Image
                                      loading="lazy"
                                      width="16px"
                                      height="16px"
                                      margin="0px 16px 0px 0px"
                                      src={Download}
                                    />
                                    Download
                                  </DropdownList>
                                </>
                              )}
                            {row.status !== "Locked" && (
                              <DropdownList
                                id="list4"
                                padding="0px 0px 3px 20px"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  HandleDelete(ind, row.id);
                                }}
                              >
                                <Image
                                  loading="lazy"
                                  width="16px"
                                  height="16px"
                                  margin="0px 16px 0px 0px"
                                  src={Delete}
                                />
                                Delete
                              </DropdownList>
                            )}
                          </DropdownContent>
                        </TableBodyCell>
                      </TableRow>
                    ))}
                  </>
                ) : (
                  <TableRow background="#FFFFF">
                    <TableBodyCell colSpan={6} textAlign="center">
                      <EmptyData height="60vh" />
                    </TableBodyCell>
                  </TableRow>
                )}
              </>
            </TableBody>
          </Table>
        </TableDiv>
      )}
      <CreateSignature
        show={iscreate}
        close={HanldeCloseSignature}
        ids={tosign}
      />
      <ViewEdit
        show={ForViewEdit}
        filename={FileName}
        filestatus={FileStatus}
        fileid={FileId}
        close={HanldeCloseViewEdit}
        forsign={ForSign}
      />

      {isFormOpened && (
        <div className="form-popup-overlay">
          <div className="form-popup">
            <PatientForm
              setIsFormOpened={setIsFormOpened}
              formData={formData}
              setFormData={setFormData}
              onSuccess={() => {
                dispatch(getDocumentslist({ filtertype: "All Documents" }));
              }}
            />
          </div>
        </div>
      )}
      {/* ─── PDF Viewer Modal ─── */}
      <Modal show={viewModalUrl !== ""} height="100%" width="100%">
        <ModalContainer justifyContent="center">
          <Div
            width="90%"
            height="96vh"
            backColor="#fff"
            borderRadius="12px"
            display="flex"
            overflow="hidden"
            style={{
              maxWidth: "900px",
              flexDirection: "column",
              boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
              animation: "modal 0.3s ease",
            }}
          >
            {/* Modal Header */}
            <Div
              borderBottom="1px solid #e0e0e0"
              height="50px"
              padding="0px 24px"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <ModalTitle
                lineHight="27px"
                fontSize="18px"
                fontWeight="600"
                color="#0a1629"
              >
                Document Preview
              </ModalTitle>
              <BsXLg
                style={{
                  cursor: "pointer",
                  height: "14px",
                  width: "14px",
                }}
                onClick={() => {
                  setViewModalUrl("");
                  dispatch(getDeleteTempDoc({ id: donwloadprintid }));
                }}
              />
            </Div>

            {/* Modal Body — PDF / Image viewer */}
            <Div
              overflow="hidden"
              padding="0"
              style={{
                flex: 1,
                width: "100%",
                height: "calc(100% - 50px)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#f4f6f8"
              }}
            >
              {(() => {
                if (viewModalUrl.match(/\.(jpeg|jpg|gif|png|webp|bmp)(\?.*)?$/i)) return true;
                const row = documentlistdata.find((r) => r.id === donwloadprintid);
                if (row) {
                  const name = (row.doc_name || row.file_url || "").toLowerCase();
                  if (name.match(/[\.-](jpeg|jpg|gif|png|webp|bmp)/i)) return true;
                }
                return false;
              })() ? (
                <img
                  src={viewModalUrl}
                  alt="Document Preview"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
                  }}
                />
              ) : (
                <iframe
                  src={viewModalUrl}
                  title="Document Preview"
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                  }}
                />
              )}
            </Div>
          </Div>
        </ModalContainer>
      </Modal>
    </>
  );
};

export default memo(DocumentTable);
